import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function MintNowIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 29 29">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1039 -6.10352e-05C21.8847 -6.10352e-05 28.205 6.48631 28.205 14.4691C28.205 22.4518 21.8847 28.9353 14.1039 28.9353C6.32323 28.9353 0 22.4513 0 14.4691C0 6.4869 6.32265 -6.10352e-05 14.1039 -6.10352e-05ZM14.1039 1.37823C7.04909 1.37823 1.34351 7.23138 1.34351 14.4691C1.34351 21.7068 7.04892 27.5576 14.1039 27.5576C21.159 27.5576 26.8621 21.7069 26.8621 14.4691C26.8621 7.2312 21.1591 1.37823 14.1039 1.37823Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1039 -6.10352e-05C21.8847 -6.10352e-05 28.205 6.48631 28.205 14.4691C28.205 22.4518 21.8847 28.9353 14.1039 28.9353C6.32323 28.9353 0 22.4513 0 14.4691C0 6.4869 6.32265 -6.10352e-05 14.1039 -6.10352e-05ZM14.1039 1.37823C7.04909 1.37823 1.34351 7.23138 1.34351 14.4691C1.34351 21.7068 7.04892 27.5576 14.1039 27.5576C21.159 27.5576 26.8621 21.7069 26.8621 14.4691C26.8621 7.2312 21.1591 1.37823 14.1039 1.37823Z"
        fill="white"
      />
      <path
        d="M25.3883 14.4674C25.3883 20.8596 20.3372 26.0415 14.1063 26.0415C7.87544 26.0415 2.82431 20.8596 2.82431 14.4674C2.82431 8.07521 7.87544 2.89329 14.1063 2.89329C20.3372 2.89329 25.3883 8.07521 25.3883 14.4674Z"
        fill="white"
      />
      <path
        d="M13.1721 9.64546C13.0953 10.2624 13.5473 11.0288 13.9584 11.2818L12.232 13.053L11.2991 12.0409C10.5592 11.2818 9.32605 12.4872 9.32605 13.053C9.32605 13.306 9.57268 13.306 9.57268 13.559L9.07942 14.065C8.58617 14.571 8.25733 14.4867 8.09291 14.318L6.85985 13.053C6.36659 12.5469 6.61322 12.2939 7.10647 11.7879C7.50108 11.3831 7.59957 11.5349 7.84628 11.7879C9.0301 11.5855 8.99729 10.3541 8.83288 9.76376L10.3126 8.24572C11.8911 6.42402 15.0808 6.6433 16.4784 6.98065V7.7397C13.7654 7.99271 13.2606 8.9356 13.1721 9.64546Z"
        fill="#0064E9"
      />
      <path
        d="M14.4281 11.7331L12.7017 13.5042L18.8342 20.4187C19.427 21.087 20.4625 21.1114 21.0861 20.4717C21.6757 19.8668 21.6671 18.8996 21.0668 18.3053L14.4281 11.7331Z"
        fill="#0064E9"
      />
    </SvgIcon>
  );
}
